import { Tag as ChakraTag } from '@chakra-ui/react';

export const Tag = ChakraTag;
